module.exports = __webpack_public_path__ + "static/media/stats-person.df43480e.svg";